export default __webpack_public_path__ + "static/media/SS3Semibold.otf.84e99d45.woff2";